// extracted by mini-css-extract-plugin
export default {"container":"p1St0nusrQHYKFSpNrwt","fader":"v2XAAFGWOW_FVwOiuLTn"};